import { ResolutionTypeId } from 'api/endpoints/actions-select-options';
import { ClaimFormField } from '../types';
import { FIELDS_APUSER_READONLY } from './isEditableApUser';

export function isEditableClient(
  field: string,
  resolutionId: ResolutionTypeId | undefined | null,
) {
  if (
    field === FIELD_SURVIVING_NUMBER &&
    resolutionId === ResolutionTypeId.Expunge
  ) {
    return true;
  }

  if ([ResolutionTypeId.Allow, ResolutionTypeId.Expunge].includes(resolutionId!)) {
    return !FIELDS_CLIENT_EXPUNGE_READONLY.includes(field as ClaimFormField);
  }

  return !FIELDS_CLIENT_READONLY.includes(field as ClaimFormField);
}

const FIELD_SURVIVING_NUMBER: ClaimFormField = 'survivingClaimNumber';

/**
 * in this file you can define permissions
 * field for client user per resolution type status
 */
const FIELDS_CLIENT_READONLY: ClaimFormField[] = [
  ...FIELDS_APUSER_READONLY,
  //Matrix fields
  'high',
  'low',
  'counsel',
  'alixPartners',

  // Claim Status
  'claimReviewer',
  'survivingClaimNumber',
  'actionStatus',
  'actionNameId',
  // 'actionSubStatusId',
  'actionReview',
  'reviewLevelId',
  'objectionCommentary',
];

const FIELDS_CLIENT_EXPUNGE_READONLY: ClaimFormField[] = [
  ...FIELDS_CLIENT_READONLY,

  'contactFullName',
  'email',
  'address1',
  'address2',
  'address3',
  'address4',
  'city',
  'phone',
  'state',
  'country',
  'zip',
  'proposedDebtor',
];
